/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './main-content';
import { Login } from './login';
/**
 * An example element.
 *
 * @fires count-changed - Indicates when the count changes
 * @slot - This element has a slot
 * @csspart button - The button
 */
let MainPage = class MainPage extends LitElement {
    constructor() {
        super();
        this.checked_login = false;
        this.inflight = false;
        this.auth_token = "";
        this.login_err = "";
        this.login = new Login();
        this.try_find_auth_token();
    }
    render() {
        return html `
			<div class="titlebar">
				<h1>Whalefall Dev Webbed Site</h1>
			</div>
			${this.checked_login
            ? this.render_login_or_content()
            : html `<p>Checking for login...</p>`}
		`;
    }
    render_login_or_content() {
        if (this.inflight) {
            return html `<p>Checking it...</p>`;
        }
        return this.auth_token
            ? html `<main-content auth=${this.auth_token}></main-content>`
            : this.render_password();
    }
    render_password() {
        return html `
			<h2>You do know the codes, right?</h2>
			<button @click=${this.submit_password}>Yeah, it's, uhh....</button>
			<input id="input-pw" type="password">
			${this.login_err ? html `<p class="error">${this.login_err}` : nothing}
		`;
    }
    async submit_password() {
        this.inflight = true;
        const input = this.shadowRoot?.getElementById("input-pw");
        const success = await this.login.login_with_password(input.value);
        if (success) {
            this.auth_token = this.login.auth.AccessToken;
        }
        else {
            this.auth_token = "";
            this.login_err = "Login failed :(";
        }
        this.inflight = false;
    }
    async try_find_auth_token() {
        const cached = await this.login.get_cached_login();
        if (cached) {
            this.auth_token = this.login.auth.AccessToken;
        }
        this.checked_login = true;
    }
};
MainPage.styles = css `
		:host {
		}
		.titlebar {
			border-bottom: 4px dotted purple;
		}
		.error {
			background-color: #111;
			color: tomato;
		}
	`;
__decorate([
    property({ type: Boolean })
], MainPage.prototype, "checked_login", void 0);
__decorate([
    property({ type: Boolean })
], MainPage.prototype, "inflight", void 0);
__decorate([
    property({ type: String })
], MainPage.prototype, "auth_token", void 0);
__decorate([
    property({ type: String })
], MainPage.prototype, "login_err", void 0);
MainPage = __decorate([
    customElement('main-page')
], MainPage);
export { MainPage };
//# sourceMappingURL=main-page.js.map